import { createModel } from "@rematch/core";
import { ProductType, TariffTypesPayload, TariffTypesState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, mapSupplyTypes, signoutIfUnauthorized } from "./utilities";

const initialState: TariffTypesState = {
  data: [],
};

export const tariffTypesHeating = createModel<RootModel>()({
  state: initialState as TariffTypesState,
  reducers: {
    fetchSuccess(state, payload: TariffTypesPayload) {
      return {
        ...state,
        data: mapSupplyTypes(payload),
      };
    },
    fetchFail(state) {
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async fetchTariffTypesHeating(payload: null, rootState) {
      const token = checkToken(rootState, () =>
        dispatch.tariffTypesHeating.fetchFail()
      );
      if (!token) return;

      try {
        const tariffTypesResult = await api.fetchTariffTypes(
          token,
          ProductType.HEATING
        );
        dispatch.tariffTypesHeating.fetchSuccess(tariffTypesResult.data);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.tariffTypesHeating.fetchFail();
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/tariffTypesHeating.ts